import React from "react";
import { Badge } from '@mantine/core';

import { sqlDateToHumanDate } from "../../utils/globalFunctions";

const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');
const duration = require('dayjs/plugin/duration');
const isBetween = require('dayjs/plugin/isBetween');
const objectSupport = require('dayjs/plugin/objectSupport');

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(objectSupport);

const DeadlinePengecekan = ({ stateToday, stateDeadlinePengecekan, stateHasPengecekan, stateMT = '0', stateIsShort = false }) => {

    const getExactDayDifference = (start, end) => {
        const startDate = dayjs(start, 'YYYY-MM-DD');
        const endDate = dayjs(end, 'YYYY-MM-DD');

        return endDate.diff(startDate, 'day');
    }

    const getMonthDayDifference = (start, end) => {
        const startDate = dayjs(start, 'YYYY-MM-DD');
        const endDate = dayjs(end, 'YYYY-MM-DD');

        const diff = endDate.diff(startDate, 'day');
        const duration = dayjs.duration(diff, 'day');

        const months = duration.months();
        const days = duration.days();

        // return `${months} bulan, ${days} hari`;

        return {
            month: months,
            day: days
        }
    }

    const Comp = ({ today, deadlinePengecekan, hasPengecekan }) => {
        const diff = getExactDayDifference(hasPengecekan ? hasPengecekan : today, deadlinePengecekan);
        const res = getMonthDayDifference(hasPengecekan ? hasPengecekan : today, deadlinePengecekan);

        const resComp = (stateData, stateDefault) => {
            return stateData ? sqlDateToHumanDate({
                stateDate: stateData,
                stateWithTime: false,
                stateLang: 'id',
                stateIsShort: stateIsShort,
                stateDay: false,
                stateDefaultValue: ' - ',
                stateDateType: 'day',
                stateWithSecond: false
            }) : stateDefault
        }

        if (diff === 0) {
            return <Badge
                size='md'
                color='orange'
                mt={stateMT}
                styles={{
                    root: {
                        fontWeight: 'normal',
                        letterSpacing: '0',
                    },
                }}
            >
                {resComp(hasPengecekan, 'Hari terakhir')}
            </Badge>
        } else if (diff > 0) {
            return <Badge
                size='md'
                color='green'
                mt={stateMT}
                styles={{
                    root: {
                        fontWeight: 'normal',
                        letterSpacing: '0',
                        height: 'auto'
                    },
                    inner: {
                        overflow: 'unset',
                        textOverflow: 'unset',
                        whiteSpace: 'normal'
                    }
                }}
            >
                {resComp(hasPengecekan, ((res.month > 0 ? `${res.month} bln, ` : '') + (res.day > 0 ? `${res.day} hr lagi` : '')))}
            </Badge>
        } else {
            return <Badge
                size='md'
                color='red'
                mt={stateMT}
                styles={{
                    root: {
                        fontWeight: 'normal',
                        letterSpacing: '0',
                        height: 'auto'
                    },
                    inner: {
                        overflow: 'unset',
                        textOverflow: 'unset',
                        whiteSpace: 'normal'
                    }
                }}
            >
                {resComp(hasPengecekan, ('Terlewat ' + (res.month < 0 ? `${res.month * -1} bln ` : '') + (Number(res.day) < 0 ? `${res.day * -1} hr` : '')))}
            </Badge>
        }
    }

    return (
        stateDeadlinePengecekan &&
        <Comp
            today={stateToday}
            deadlinePengecekan={stateDeadlinePengecekan}
            hasPengecekan={stateHasPengecekan}
        />
    )
}

export default DeadlinePengecekan;